import { orderBy } from 'lodash';
import { FocusEvent } from 'react';

import { IBellNotification } from 'notifications/types';
import { isIframePath } from 'router/utils/iframe';

export const MAX_VISIBLE_NOTIFICATION_TOASTS = 4;
export const NOTIFICATION_TOAST_AUTO_CLOSE_MS = 8000;

// The iframe routes render inside the Outlook add-in, which never shows notification toasts.
// The order's own page gets the card too: it needs a refresh to show the new state. On order submit
// the card is the only popup — the page and the Submit Order drawer show no banner of their own.
export const isNotificationToastSuppressed = (pathname: string): boolean => isIframePath(pathname);

// Newest first, the order the stack shows them in.
export const planNotificationToasts = (
  arrivals: IBellNotification[],
  pathname: string
): IBellNotification[] =>
  isNotificationToastSuppressed(pathname) ? [] : orderBy(arrivals ?? [], 'id', 'desc');

// The newest cards show; an older one waits until a card above it closes.
export const getVisibleNotificationToasts = <T>(toasts: T[]): T[] =>
  (toasts ?? []).slice(0, MAX_VISIBLE_NOTIFICATION_TOASTS);

// Cards behave like phone banners: every one closes on its own, whatever its severity, and the
// bell keeps the history (Oana, 2026-09-24).
export const getNotificationToastAutoCloseMs = (): number => NOTIFICATION_TOAST_AUTO_CLOSE_MS;

// Focus moving between the controls of one card or of the stack must not count as leaving it.
export const isFocusLeaving = (event: FocusEvent<HTMLElement>): boolean =>
  !event.currentTarget.contains(event.relatedTarget as Node | null);
